import { API_BASE_URL } from './apiBaseUrl';

export interface AuthUser {
  id: string;
  email: string;
  displayName: string;
  avatarUrl?: string;
}

interface ApiResponse<T> {
  success: boolean;
  data?: T;
  message?: string;
  error?: {
    message?: string;
  };
}

export const getGoogleLoginUrl = (): string => `${API_BASE_URL}/auth/google`;

export const getCurrentUser = async (token: string): Promise<AuthUser> => {
  const response = await fetch(`${API_BASE_URL}/auth/me`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
  });

  const payload = (await response.json()) as ApiResponse<AuthUser>;

  if (!response.ok || !payload.success || !payload.data) {
    throw new Error(payload.error?.message || payload.message || 'Session invalide');
  }

  return payload.data;
};

export const logoutSession = async (token: string): Promise<void> => {
  await fetch(`${API_BASE_URL}/auth/logout`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
  });
};
